import { Component, OnInit } from '@angular/core';
import { loading } from '../../../core/main.interceptor';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	standalone: true,
})
export class LoaderComponent implements OnInit {
	constructor() {}

	ngOnInit() {}

	protected readonly loading = loading;
}
